export const hideExamMarkers = true;
export const hideExamBarcode = true;
export const questionBankExamAndOnly = true;